import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faComments,
    faInbox,
    faTrashAlt,
    faUserSecret,
} from '@fortawesome/free-solid-svg-icons'
import RequestQueue from '../../api/requestQueue'
import Loading from '../../component/loading'
import { toast } from 'react-toastify'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import { AppContextMenu } from '../../App'

const AnonymousMessage = () => {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('anonymousMessage')
    }, [])

    const [loading, setLoading] = useState(false)

    const [messages, setMessages] = useState([])
    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/anonymous-message`,
            },
            resolve: (res) => {
                setMessages(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ازتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handleDelete = async (id) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'delete',
                url: `/anonymous-message/${id}`,
            },
            resolve: (res) => {
                setLoading(false)
                fetchData()
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ازتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    {/* Messages List */}
                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faInbox}
                                    className="ml-2"
                                />
                                پیام‌های ناشناس
                            </h2>
                        </div>
                        <div className="p-6">
                            {messages.length === 0 ? (
                                <div className="text-center py-8 text-gray-500">
                                    <FontAwesomeIcon
                                        icon={faComments}
                                        className="text-4xl mb-3"
                                    />
                                    <p>هنوز پیامی دریافت نکرده‌اید</p>
                                </div>
                            ) : (
                                <div className="space-y-4">
                                    {messages.map((msg, index) => (
                                        <div
                                            key={index}
                                            className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors"
                                        >
                                            <div className="flex justify-between items-start">
                                                <div className="flex items-center">
                                                    <div className="bg-gray-100 p-2 rounded-full ml-3">
                                                        <FontAwesomeIcon
                                                            icon={faUserSecret}
                                                            className="text-gray-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <p className="text-sm text-gray-500">
                                                            پیام ناشناس
                                                        </p>
                                                        <p className="text-xs text-gray-400">
                                                            {FormJsonToShamsiDay(
                                                                msg.created_at
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                                <button
                                                    onClick={() =>
                                                        handleDelete(msg.id)
                                                    }
                                                    className="text-red-500 hover:text-red-700"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTrashAlt}
                                                    />
                                                </button>
                                            </div>
                                            <div className="mt-3 text-gray-700">
                                                {msg.content}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}
export default AnonymousMessage
